<template>
  <div id="ssr-page" class="ssr-page official-passport-page">
    <router-view v-if="visible"></router-view>
    <Popup
      type="confirm"
      @onCancel="beforeCloseWebview"
      @onConfirm="beforeCloseWebview"
      v-bind:visible.sync="loginFail"
      :languages="languages"
      :content="loginFailTips"
    ></Popup>
  </div>
</template>
<script>
import globalConfig from '@utiles/globalConfig';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import bridge from '@utiles/bridge';
import { LOGIN, PAGE_INIT } from '@store/officialPassport/account';
import { pageType, viewPage } from '@plugins/biPoint/_configOfficialPassport';
import { GET_SKIN, SET_PASSPORT_SKIN } from '@store/sdkSkin';
import { CHECK_IP_LOCATION } from '@store/ipCheck';
import { LOAD_USER_INFO } from '@store/officialPassport/accountSetting';
import { GET_CONFIG, GET_GAME, GET_MENU } from '@store/officialPassport';
import sdkBridge from '@mixins/officialPassport/sdkBridge';
import { initBiPoint } from '@plugins/biPoint/index';
import getPageLoadInfo from '@utiles/getPageLoadInfo';

export default {
  mixins: [sdkBridge],
  data() {
    return {
      platformClass: '',
      loginFail: false,
      loginFailTips: '',
      visible: false,
      timeRecord: {
        start: 0,
        sdkReady: 0,
        sdkInit: 0,
        loginReq: 0,
        skinReq: 0
      }
    };
  },
  async created() {
    try {
      await this.loadSkin();
    } catch (e) {
      console.error(e);
    }
    this.timeRecord.start = this.getCurrentTime();
    this.initParams();
    this.initSDKBridge();
  },
  computed: {
    languages() {
      return this.$store.state.languages;
    }
  },
  methods: {
    getCurrentTime() {
      return new Date().getTime();
    },
    initParams() {
      try {
        globalConfig.storeEntryParams();
      } catch (e) {
        console.error(e);
      }
    },
    initSDKBridge() {
      bridge.onReady(() => {
        this.timeRecord.sdkReady = this.getCurrentTime();
        // sdk触发准备事件,不应该弄掉这一行！确保sdk 已经往前端注入方法，否则调用下面可能会报错。
        this.$store
          .dispatch(PAGE_INIT)
          .then(loginPath => {
            this.timeRecord.sdkInit = this.getCurrentTime();
            this.$store
              .dispatch(LOGIN, loginPath)
              .then(({ logined, errmsg, data }) => {
                this.timeRecord.loginReq = this.getCurrentTime();
                if (logined) {
                  // 登录接口完成后才初始化打点。test_ip接口会覆盖登录态
                  initBiPoint({ dataLayerName: 'officialPassportDataLayer' });
                  updateCommonParamsInfo({
                    loginAccount: globalConfig.getHrefParam('loginAccount'),
                    uid: globalConfig.getHrefParam('userId'),
                    roleId: globalConfig.getHrefParam('roleId'),
                    roleName: globalConfig.getHrefParam('roleName'),
                    serverId: globalConfig.getHrefParam('serverId'),
                    language: globalConfig.getHrefParam('language'),
                    packageVersion: globalConfig.getHrefParam('packageVersion'),
                    sdkVersion: globalConfig.getHrefParam('sdkVersion'),
                    osVersion: globalConfig.getHrefParam('osVersion'),
                    phoneModel: globalConfig.getHrefParam('phoneModel'),
                    idfa: globalConfig.getHrefParam('idfa'),
                    afid: globalConfig.getHrefParam('apps')
                  });
                  this.$store.dispatch(CHECK_IP_LOCATION);
                  this.$store.dispatch(LOAD_USER_INFO, { errmsg });
                  this.$store.dispatch(GET_CONFIG);
                  this.$store.dispatch(GET_GAME);
                  this.$store.dispatch(GET_MENU);
                } else {
                  this.showLoginFailWindow(errmsg);
                }
                // 登录接口完成才进行打点草错，test_ip接口会覆盖登录态
                viewPage(pageType.userCenter);
              });
          })
          .catch(err => {
            console.error(err);
            this.showLoginFailWindow(err.message);
          });
      });
    },
    loadSkin() {
      window.initViewport(true);
      return this.$store.dispatch(GET_SKIN, SET_PASSPORT_SKIN).then(() => {
        this.timeRecord.skinReq = this.getCurrentTime();

        this.visible = true;
        // 上报SDK用户中心已加载完成
        if (document.readyState === 'complete') {
          this.callSdkLoadEnd();
        } else {
          window.addEventListener('load', () => {
            this.callSdkLoadEnd();
          });
        }
      });
    },
    callSdkLoadEnd() {
      const params = {
        sdkReady: this.timeRecord.sdkReady - this.timeRecord.start, // 首页开始运行 到 SDK方法可以使用的等待时长
        sdkInit: this.timeRecord.sdkInit - this.timeRecord.start, // 首页开始运行 到 SDK初始化时长
        loginReq: this.timeRecord.loginReq - this.timeRecord.start, // 首页开始运行 到 登录接口请求时长
        skinReq: this.timeRecord.skinReq - this.timeRecord.start, // 首页开始运行 到 皮肤接口请求时长
        ...getPageLoadInfo()
      };
      bridge.callSdkMethod('trackLoadEnd', params);
    },
    showLoginFailWindow(errmsg) {
      this.loginFail = true;
      this.loginFailTips = errmsg;
    },
    beforeCloseWebview() {
      this.loginFail = false;
      this.closeWebview();
    }
  }
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
.ssr-page {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
@import '@assets/scss/base.scss';
@import '@assets/scss/sdkSkin.scss';
@import '@assets/scss/officialPassport/officialPassport-animate.scss';
@import '@assets/scss/officialPassport/officialPassport.scss';
@import '@assets/scss/officialPassport/font/iconfont.scss';

.official-passport-page {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: blur(4px);
  }
  .container {
    position: relative;
    overflow-x: hidden;
    width: 76%;
    height: 100%;
    background-color: #ffffff;
  }
}
</style>
